export default __webpack_public_path__ + "static/media/a.75cd9446.png";